import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
}
const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-307">
      <button className="flex justify-between items-center w-full py-4 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-308">
        <span className="text-lg font-medium text-gray-900" data-id="element-309">{question}</span>
        <span data-id="element-310">
          {isOpen ? <ChevronUp className="h-5 w-5 text-rose-900" data-id="element-311" /> : <ChevronDown className="h-5 w-5 text-rose-900" data-id="element-312" />}
        </span>
      </button>
      {isOpen && <div className="pb-4 pr-4" data-id="element-313">
          <div className="text-gray-600 prose-sm" data-id="element-314">{answer}</div>
        </div>}
    </div>;
};
export const FAQ = () => {
  return <div className="bg-white" data-id="element-315">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-316">
        <div className="text-center" data-id="element-317">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-318">
            Frequently Asked Questions
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-319">
            Find answers to common questions about Suretask's appliance repair
            services and service plans.
          </p>
        </div>
        <div className="mt-12 max-w-4xl mx-auto bg-white rounded-lg shadow-md overflow-hidden" data-id="element-320">
          <div className="p-6" data-id="element-321">
            <FAQItem question="How Can I Contact Customer Support?" answer={<div data-id="element-323">
                  <p data-id="element-324">You can reach us by:</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-325">
                    <li data-id="element-326">
                      Email:{' '}
                      <a href="mailto:angelene18inandan@gmail.com" className="text-rose-900 hover:underline" data-id="element-327">
                        angelene18inandan@gmail.com
                      </a>
                    </li>
                    <li data-id="element-328">
                      Phone:{' '}
                      <a href="tel:08000554969" className="text-rose-900 hover:underline" data-id="element-329">
                        0800 055 4969
                      </a>
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-330">
                    Our support team is available Monday to Friday from 9 am to
                    5 pm. Messages received outside these hours will be
                    responded to on the next working day.
                  </p>
                </div>} data-id="element-322" />
            <FAQItem question="When Does My Service Plan Start and End?" answer={<div data-id="element-332">
                  <p data-id="element-333">
                    Your Suretask coverage begins as soon as your payment is
                    confirmed. For example, if you purchase a 12-month plan on
                    15 July, your protection lasts until 23:59 on 14 July the
                    following year.
                  </p>
                  <p className="mt-2" data-id="element-334">
                    <strong data-id="element-335">Activation:</strong> Your plan activates immediately
                    after payment clears. A confirmation email will be sent
                    straight away. No further action is needed on your part.
                    Coverage lasts for 12 months from the purchase date.
                  </p>
                  <p className="mt-2" data-id="element-336">
                    <strong data-id="element-337">Expiry:</strong> Your plan ends exactly 12 months
                    later at 23:59, unless you choose to renew for continuous
                    protection.
                  </p>
                </div>} data-id="element-331" />
            <FAQItem question="How Do I Request a Repair?" answer={<div data-id="element-339">
                  <p data-id="element-340">Contact Suretask at:</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-341">
                    <li data-id="element-342">
                      📞{' '}
                      <a href="tel:08000554969" className="text-rose-900 hover:underline" data-id="element-343">
                        0800 055 4969
                      </a>
                    </li>
                    <li data-id="element-344">
                      📧{' '}
                      <a href="mailto:angelene18inandan@gmail.com" className="text-rose-900 hover:underline" data-id="element-345">
                        angelene18inandan@gmail.com
                      </a>
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-346">
                    We typically schedule repair appointments within 24 to 48
                    hours.
                  </p>
                </div>} data-id="element-338" />
            <FAQItem question="What Does 'Unlimited Repairs' Mean?" answer={<div data-id="element-348">
                  <p data-id="element-349">
                    You may request unlimited repair visits and technician time
                    for all essential appliances covered under your Suretask
                    plan (such as your washing machine, TV, or refrigerator).
                  </p>
                  <p className="mt-2" data-id="element-350">
                    <strong data-id="element-351">Please note:</strong> Appliances older than 10
                    years, accidental or liquid damage, and general wear and
                    tear not caused by mechanical or electrical faults are
                    excluded.
                  </p>
                </div>} data-id="element-347" />
            <FAQItem question="Cooling-Off and Refunds" answer={<div data-id="element-353">
                  <p data-id="element-354">
                    Yes. You can cancel within 14 days of purchase for a full
                    refund, provided no repair work has started.
                  </p>
                  <p className="mt-2" data-id="element-355">
                    Cancellations made between days 15 and 28 may be eligible
                    for a partial refund, at our discretion, taking into account
                    any services already rendered.
                  </p>
                  <p className="mt-2" data-id="element-356">No refunds are offered after 28 days.</p>
                  <p className="mt-2" data-id="element-357">
                    To cancel, email{' '}
                    <a href="mailto:angelene18inandan@gmail.com" className="text-rose-900 hover:underline" data-id="element-358">
                      angelene18inandan@gmail.com
                    </a>{' '}
                    or call{' '}
                    <a href="tel:08000554969" className="text-rose-900 hover:underline" data-id="element-359">
                      0800 055 4969
                    </a>{' '}
                    with your order number.
                  </p>
                  <p className="mt-2" data-id="element-360">
                    Refunds will be processed to your original payment method
                    within 7 to 10 working days.
                  </p>
                </div>} data-id="element-352" />
            <FAQItem question="What Appliances and Faults Are Covered?" answer={<div data-id="element-362">
                  <p data-id="element-363">
                    <strong data-id="element-364">Included:</strong> Mechanical and electrical faults
                    on registered appliances (e.g., breakdowns, faulty
                    components for your washing machine, TV, or refrigerator).
                  </p>
                  <p className="mt-2" data-id="element-365">
                    <strong data-id="element-366">Excluded:</strong> Accidental or liquid damage,
                    unregistered appliances, and appliances exceeding the age
                    limit.
                  </p>
                </div>} data-id="element-361" />
            <FAQItem question="How Quickly Can I Book an Appointment?" answer={<div data-id="element-368">
                  <p data-id="element-369">
                    We aim to respond within 48 hours to arrange a visit. Most
                    local repairs are booked within 3 to 5 working days.
                  </p>
                  <p className="mt-2" data-id="element-370">
                    For remote locations or busy periods, scheduling may take
                    longer, but we will discuss alternative timings with you.
                  </p>
                </div>} data-id="element-367" />
            <FAQItem question="Do You Cover the Whole UK?" answer={<div data-id="element-372">
                  <p data-id="element-373">Yes. Our services cover England, Scotland, and Wales.</p>
                  <p className="mt-2" data-id="element-374">
                    Please check availability for remote postcodes before
                    purchasing.
                  </p>
                </div>} data-id="element-371" />
            <FAQItem question="If a Repair Does Not Resolve the Fault" answer={<div data-id="element-376">
                  <p data-id="element-377">
                    Contact Suretask immediately. If the issue cannot be fixed
                    after reasonable attempts, you may qualify for a pro-rated
                    refund or replacement credit for faults reported within your
                    coverage period.
                  </p>
                </div>} data-id="element-375" />
            <FAQItem question="Payment Methods Accepted" answer={<div data-id="element-379">
                  <p data-id="element-380">We accept:</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-381">
                    <li data-id="element-382">Credit and debit cards (Visa, Mastercard)</li>
                    <li data-id="element-383">Apple Pay and Google Pay</li>
                    <li data-id="element-384">BACS or Direct Debit</li>
                  </ul>
                  <p className="mt-2" data-id="element-385">
                    All payments are processed in GBP upon confirmation.
                  </p>
                </div>} data-id="element-378" />
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-386">
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-387">
            Can't find what you're looking for? Our friendly customer service
            team is ready to help with any questions you may have.
          </p>
          <div className="mt-6" data-id="element-388">
            <a href="/contact" className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500" data-id="element-389">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>;
};